import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';

import {
  CardPayment,
  CreateTokenResponse,
  ResponseInstallment,
  PaymentResult,
} from '../models/mercadopago.model';
import { MercadopagoApiService } from '../services/mercadopago.api.service';

declare var Mercadopago: any;

@Component({
  selector: 'mp-form-pay',
  templateUrl: './mercadopago.component.html',
  styleUrls: ['./mercadopago.component.scss']
})
export class MercadoPagoComponent implements OnInit, OnChanges {

  totalAmount: number;
  totalFinancedAmount: number;
  currentBin: string;
  recommendedLabel: string;
  currentTEA: string;
  currentCFT: string;
  ticket: string;
  defaultName: string;
  defaultDocType: string;
  issuerId: string;
  currentPaymentMethod: any;
  currentIssuers: any[];
  currentInstallments: any[];
  cardPayment: CardPayment;

  // input bind
  yearText: string;
  monthText: string;
  dniText: string;
  cvcText: string;
  cardText: string;
  errorMessage: string;

  paymentState = 'unsubmitted';
  tokenId = '';
  disabled = false;
  addScript = false;
  requiredIssuer = false;
  submitted = false;

  paymentResult: PaymentResult = { success: false, paymentId: '', integrator: 'MP' };

  @Input() paymentAmount: number;
  @Input() payerName: string;
  @Input() payerEmail: string;
  @Input() accessToken: string;
  @Input() vkUrlApi: string;
  @Input() description: string;
  @Input() publishableKey: string;
  @Input() successUrl: string;
  @Input() failureUrl: string;
  @Input() imgCreditCards: string;
  @Input() imgMercadoPago: string;
  @Input() iconExpandMore: string;
  @Input() debugLog: boolean;
  @Input() storeId: string;
  @Input() idVen: number;
  @Input() data: string;
  @Output() statusPay = new EventEmitter<PaymentResult>();

  @ViewChild('f') checkOutForm: NgForm;

  constructor(private router: Router, private mercadopagoApiService: MercadopagoApiService) { }

  ngOnInit() {
    this.initMercadoPago();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.paymentAmount.isFirstChange()) {
      this.disabled = false;
      this.checkOutForm.reset();
    }
  }

  private initMercadoPago() {
    this.addMercadopagoScript()
      .then(() => {
        Mercadopago.setPublishableKey(this.publishableKey);
        Mercadopago.getIdentificationTypes();

        this.totalAmount = this.paymentAmount;
        this.defaultName = this.payerName;
        this.defaultDocType = 'DNI';
      });
  }

  private addMercadopagoScript() {
    this.addScript = true;
    return new Promise((resolve, reject) => {
      const scripttagElement = document.createElement('script');
      scripttagElement.src = 'https://secure.mlstatic.com/sdk/javascript/v1/mercadopago.js?2345';
      scripttagElement.onload = resolve;
      document.body.appendChild(scripttagElement);
    });
  }

  private createToken(sendForm: any) {
    this.paymentState = 'processing';
    Mercadopago.createToken(sendForm, (status, response: any) => {
      if (status !== 200 && status !== 201) {
        this.paymentState = 'error';
        this.statusPay.emit(this.paymentResult);
        this.errorMessage = 'Revisa los datos del formulario.';
        // const causes: Cause[] = (response as ErrorTokenResponse).cause;
        // if (causes !== null && causes.length > 0) {
        //   causes.forEach((item) => {
        //     this.errorMessage += this.getErrorMessage(item.code) + '\n';
        //   });
        // }
      } else {
        this.tokenId = (response as CreateTokenResponse).id;
        this.makePayment();
      }
    });
  }

  private makePayment() {
    this.cardPayment = {
      tokenId: this.tokenId,
      transactionAmount: this.totalAmount,
      description: this.description,
      installments: Number(this.checkOutForm.value.installments),
      issuerId: this.checkOutForm.value.issuer,
      paymentMethodId: this.currentPaymentMethod[0].id,
      codCP: this.idVen,
      docNumber: this.checkOutForm.value.docNumber,
      additionalData: this.data,
      storeId: this.storeId
    };

    this.mercadopagoApiService.makePayment(this.cardPayment, this.accessToken, this.vkUrlApi)
      .subscribe(res => {
        this.paymentResponseHandler(res);
      }, error => {
        this.statusPay.emit(this.paymentResult);
        this.paymentState = 'apiError';
        console.log(error);
      });
  }

  private paymentResponseHandler(response: any) {
    if (response.success) {
      this.paymentState = response.data.statusDetails;
      this.ticket = response.data.transactionId;
      this.paymentResult = { success: true, paymentId: this.ticket, integrator: 'MP' };
      this.statusPay.emit(this.paymentResult);
      this.disabled = true;

      this.logger('paymentResponseHandler:', response);
      if (this.successUrl && this.successUrl.length > 0) {
        this.router.navigate([`${this.successUrl}`]);
      }
    } else {
      this.paymentState = 'apiError';
      this.statusPay.emit(this.paymentResult);
      if (this.successUrl && this.failureUrl.length > 0) {
        this.router.navigate([`${this.failureUrl}`]).then();
      }
    }
  }

  checkPaymentMethod() {
    if (this.checkOutForm.value.cardNumber != null) {
      this.currentInstallments = null;
      this.currentIssuers = null;
      if (this.checkOutForm.value.cardNumber.toString().length >= 6) {
        this.currentBin = this.checkOutForm.value.cardNumber.toString().substring(0, 6);
        const self = this;
        Mercadopago.getPaymentMethod(
          {
            'bin': this.checkOutForm.value.cardNumber.toString()
          }, function (respCode, respBody) {
            if (respCode === 200) {
              self.setCurrentMethod(respBody);
            }
          });
      }
      if (this.checkOutForm.value.cardNumber.toString().length < 6) {
        this.requiredIssuer = false;
      }
    }
  }

  setCurrentMethod(res: any) {
    if (res) {
      this.logger('setCurrentMethod:', res);
      this.currentPaymentMethod = res;
      this.requiredIssuer = true;
      const self = this;
      Mercadopago.getIssuers(res[0].id, function (respCode, respBody) {
        if (respCode === 200) {
          self.setIssuers(respBody);
        }
      });
      if (!this.requiredIssuer) {
        self.checkInstallments();
      }
    }
  }

  checkInstallments() {
    if (this.currentBin == undefined || this.currentBin.length < 6) {
      return;
    }
    const self = this;
    self.currentInstallments = null;
    Mercadopago.getInstallments({
      'bin': this.currentBin,
      'amount': this.totalAmount
    }, function (respCode, respBody) {
      if (respCode === 200) {
        self.setInstallments(respBody);
      } else {
        self.currentInstallments = null;
      }
    });
  }

  setInstallments(res: ResponseInstallment[]) {
    this.logger('setInstallments:', res);
    if (res.length > 0) {
      this.currentInstallments = res[0].payer_costs;
      this.issuerId = res[0].issuer.id;
    }
  }

  setIssuers(res: any) {
    this.logger('setIssuers res', res);
    this.currentIssuers = res;
  }

  onDuesSelection(res: any) {
    for (const ins of this.currentInstallments) {
      if (ins.installments === Number(res.value.installments)) {
        this.totalFinancedAmount = ins.total_amount;
        for (const label of ins.labels) {
          if (label.includes('CFT')) {
            this.recommendedLabel = label.replace(/_/g, ': ').split('|', 2);
            this.currentTEA = this.recommendedLabel[1];
            this.currentCFT = this.recommendedLabel[0];
          }
        }
      }
    }
  }

  onSubmit(form: NgForm) {
    this.submitted = true;
    this.paymentResult = { success: false, paymentId: '', integrator: 'MP' };
    if (this.checkOutForm.valid) {
      const sendForm = {
        cardNumber: this.cardText,
        securityCode: this.cvcText,
        cardExpirationMonth: this.monthText,
        cardExpirationYear: this.yearText,
        cardholderName: this.defaultName,
        docType: this.defaultDocType,
        docNumber: this.dniText
      };

      if (this.debugLog) {
        console.log('sendForm', sendForm);
      }

      if (this.tokenId !== '') {
        Mercadopago.clearSession();
      }

      this.createToken(sendForm);
    }
  }

  // Input controls
  onYearChange() {
    if (isNaN(+this.yearText)) {
      setTimeout(() => {
        this.yearText = '';
      });
    }
  }

  onMonthLostFocus() {
    if (+this.monthText > 0 && !isNaN(+this.monthText)) {
      if (this.monthText == '1') {
        this.monthText = '01';
      }
    }
  }

  onMonthChange() {
    if (+this.monthText >= 0 && +this.monthText < 13 && !isNaN(+this.monthText)) {
      switch (this.monthText) {
        case '2': {
          this.monthText = '02';
          break;
        }
        case '3': {
          this.monthText = '03';
          break;
        }
        case '4': {
          this.monthText = '04';
          break;
        }
        case '5': {
          this.monthText = '05';
          break;
        }
        case '6': {
          this.monthText = '06';
          break;
        }
        case '7': {
          this.monthText = '07';
          break;
        }
        case '8': {
          this.monthText = '08';
          break;
        }
        case '9': {
          this.monthText = '09';
          break;
        }
      }
    } else {
      setTimeout(() => {
        this.monthText = '';
      });
    }
  }

  onCodeChange() {
    if (isNaN(+this.cvcText)) {
      setTimeout(() => {
        this.cvcText = '';
      });
    }
  }
  onDniChange() {
    if (isNaN(+this.dniText)) {
      setTimeout(() => {
        this.dniText = '';
      });
    }
  }

  onPayerNameChange() {
    if (!isNaN(+this.defaultName)) {
      setTimeout(() => {
        this.defaultName = '';
      });
    }
  }

  onCardChange() {
    if (isNaN(+this.cardText)) {
      setTimeout(() => {
        this.cardText = '';
      });
    }
  }

  onPaste(): boolean {
    return false;
  }

  logger(message: string, data: any): void {
    if (this.debugLog) {
      console.log(message, JSON.stringify(data));
    }
  }
}
